export const siteResources = {
  en: {
    common: {
      languageLabel: "Switch to Arabic",
      whatsappLabel: "Chat on WhatsApp",
      learnMore: "Learn more",
      contactSanaya: "Contact Sanaya",
      download: "Download",
      viewCatalog: "View catalog",
    },
    nav: {
      odooPlans: "Odoo plans",
      home: "Home",
      about: "About",
      partners: "Partners",
      solutions: "Solutions",
      services: "Services",
      team: "Team",
      academy: "Academy",
      packages: "Packages",
      contact: "Contact",
      products: "Products",
      portal: "Portal",
      profile: "Profile 2026",
      downloadProfile: "Download Profile 2026",
      supportCta: "Odoo Support",
      support: "Support",
      homeLabel: "Go to homepage",
      menuLabel: "Toggle menu",
    },
    landing: {
      badge: "Baghdad-Based Technology Company",
      title: "Building the",
      titleAccent: "infrastructure behind modern business.",
      intro: "Alsanaya Alarabia designs, secures, and operates critical technology systems for ambitious organizations. We combine data centers, software, networking, fire safety, and ERP into one delivery partner.",
      explore: "Explore Solutions",
      consultation: "Book a Consultation",
      trustItems: ["Data Centers", "Software Engineering", "Infrastructure Security", "ERP Transformation"],
      snapshot: "Delivery Snapshot",
      snapshotTitle: "One partner for mission-critical technology",
      active: "Active",
      stats: ["Enterprise-grade delivery", "End-to-end digital infrastructure", "Scalable technology environments"],
      architecture: "Technology transformation starts with architecture.",
      scale: "From physical infrastructure to business software, Sanaya designs systems that scale cleanly."
    },
    about: {
      imageAlt: "Sanaya office and technology infrastructure",
      imageKicker: "Built For Critical Environments",
      imageText: "We help institutions modernize with resilient infrastructure, intelligent systems, and delivery teams that understand operational risk.",
      kicker: "About Sanaya",
      title: "A technology company focused on the systems your business depends on every day.",
      intro: "At Alsanaya Alarabia, we deliver the infrastructure, applications, and advisory services that keep organizations secure, connected, and ready to grow. Our work spans enterprise facilities, digital platforms, and mission-critical support.",
      metrics: [
        { "label": "Focus", "value": "Enterprise tech" },
        { "label": "Coverage", "value": "Infrastructure to apps" },
        { "label": "Approach", "value": "Consult, build, support" }
      ],
      highlights: ["Certified and specialized technical teams", "Turnkey execution from strategy to deployment", "Infrastructure, security, and software under one roof"],
      capabilities: [
        { "title": "Integrated delivery", "text": "We connect facilities, networks, security systems, and software into one operational ecosystem." },
        { "title": "Solution thinking", "text": "Every engagement is designed around business continuity, scalability, and measurable performance." },
        { "title": "Fast execution", "text": "Our teams move from assessment to implementation with clear ownership and minimal friction." }
      ]
    },
    mission: {
      vision: "Vision",
      visionTitle: "Raise the standard for technology delivery in Iraq and beyond.",
      visionText: "We aim to be the company organizations choose when they need modern infrastructure, dependable systems, and practical innovation that improves real operations.",
      mission: "Mission",
      missionTitle: "Equip clients with expert guidance, modern systems, and accountable execution.",
      missionText: "Our mission is to deliver the right combination of consultancy, engineering, products, and support so customers can make confident technology decisions and see them implemented well.",
      principles: [
        { "title": "Reliability first", "text": "We prioritize uptime, resilience, and operational confidence in every system we deliver." },
        { "title": "Customer partnership", "text": "Our goal is to be the team clients trust when the work is complex and the stakes are high." }
      ]
    },
    solutions: {
      kicker: "Core Solutions",
      title: "Technology capabilities designed like a modern solutions company, not a reseller catalog.",
      intro: "We focus on high-impact systems that shape uptime, security, workflow efficiency, and digital growth. Each solution line is delivered with consulting, implementation, and long-term support.",
      solution: "Solution",
      details: "See solution details",
      items: [
        { "title": "Odoo ERP Systems", "description": "We implement tailored Odoo environments that unify finance, HR, operations, sales, and service workflows into one scalable business platform." },
        { "title": "Data Centers", "description": "Sanaya designs and deploys resilient data center environments with power continuity, advanced cooling, physical security, and performance-first architecture." },
        { "title": "Fire Alarm Systems", "description": "Addressable, wireless, and integrated monitoring systems engineered for fast response, compliance, and dependable protection across facilities." },
        { "title": "Software Engineering", "description": "We build web and mobile products, internal platforms, and operational tools that bring reliability, speed, and clarity to business workflows." },
        { "title": "Networking & Security", "description": "From switching and wireless to perimeter defense and endpoint policy, we build secure connectivity for distributed organizations and critical sites." },
        { "title": "Oil & Gas Security", "description": "Integrated Hikvision security and HSE systems for fields, pipelines, refineries, and remote operations." },
        { "title": "HikFire Safety", "description": "Connected fire detection, alarm, video verification, and emergency management for buildings and industrial sites." }
      ]
    },
    consulting: {
      kicker: "Service Model",
      title: "Beyond products, we stay involved through strategy, rollout, and support.",
      intro: "We help define the plan, execute the work, and remain accountable after launch.",
      items: [
        { "title": "Consulting Services", "description": "Assessments, architecture planning, and technology roadmaps that align IT investments with business priorities." },
        { "title": "Support Services", "description": "Operational support for critical environments with rapid response, issue handling, and ongoing system optimization." },
        { "title": "Deployment Services", "description": "On-site and remote execution for rollouts, migrations, integrations, and production-ready technical delivery." }
      ]
    },
    partners: {
      kicker: "Strategic Partners",
      title: "Trusted technology alliances across infrastructure, security, communications, and enterprise systems.",
      intro: "Our vendor ecosystem lets us build solutions with proven hardware and software platforms while keeping delivery unified through one team.",
      categories: ["Data Center & Power", "Fire Safety", "Structured Cabling", "Surveillance & Smart Systems", "Communication Systems", "Network Security"]
    },
    contact: {
      labels: { "email": "Email", "phone": "Phone", "whatsapp": "WhatsApp", "office": "Office" },
      chat: "Chat with our team",
      kicker: "Contact",
      title: "Let’s build the next phase of your technology stack.",
      intro: "Reach out for infrastructure projects, software builds, digital transformation, or long-term support. We’ll help map the right next move.",
      address: "6th Floor, Al-Masar Building, Sinaa'a Street, Baghdad, Iraq",
      formTitle: "Start the conversation",
      formIntro: "Tell us what you’re building, upgrading, or fixing. We’ll respond with the right team and the right next step.",
      name: "Your name",
      namePlaceholder: "How should we address you?",
      email: "Work email",
      message: "Project brief",
      messagePlaceholder: "Tell us about the challenge, timeline, or system you want to improve.",
      submit: "Send message",
      success: "Your message has been sent successfully.",
      required: "All fields are required.",
      failed: "Failed to send email. Please try again."
    },
    footer: {
      text: "Alsanaya Alarabia builds enterprise technology systems across infrastructure, software, security, and support."
    },
    team: {
      ticker: ["Building Reliable Systems", "Engineering + Infrastructure + Operations", "Client-Focused Delivery"],
      kicker: "Meet The People Behind Sanaya",
      intro: "Leadership, engineering, and operations working together to deliver reliable systems and measurable outcomes.",
      tags: ["Infrastructure", "Data Center", "Software Engineering", "Odoo", "Support & Delivery"],
      title: "Our Team",
      members: [
        { "role": "Chief Executive Officer", "description": "Sets company direction, drives strategic partnerships, and ensures every major initiative delivers measurable business value.", "quote": "Clear ownership and measurable milestones are how great teams scale." },
        { "role": "Chief Technology Officer", "description": "Owns the technology roadmap, architecture standards, and engineering quality across software, infrastructure, and integrations.", "quote": "Technology decisions should reduce complexity today and create options for tomorrow." },
        { "role": "Basra Branch Manager", "description": "Leads Basra operations, coordinates local project execution, and maintains strong client communication and service consistency.", "quote": "Strong local execution is built on discipline, communication, and trust." },
        { "role": "Lead Software Engineer & Product Architect", "description": "Lead Software Engineer, Software Project Manager, R&D, Certified Odoo v19 Functional Consultant | BSc Computer Engineering", "quote": "It's doable, but is it within your scope?" },
        { "role": "Network Engineer", "description": "Builds and maintains secure, high-availability network environments for enterprise and data center operations.", "quote": "A stable network is invisible at its best and critical at every moment." },
        { "role": "IT & Infrastructure Engineer", "description": "Maintains core IT systems, supports infrastructure rollout, and ensures secure day-to-day business continuity.", "quote": "Reliable infrastructure is the foundation that lets every team move faster." },
        { "role": "Graphic Designer & Marketing Specialist", "description": "Creates brand visuals, campaign assets, and digital content that strengthen Sanaya's presence across marketing channels.", "quote": "Great design communicates value before a single word is read." },
        { "role": "Product Manager", "description": "Translates business needs into clear product requirements, aligns teams on priorities, and keeps delivery focused on user impact.", "quote": "Great products come from listening closely and shipping with purpose." },
        { "role": "Lawyer", "description": "Provides legal guidance on contracts, compliance, and risk to protect operations and support confident business decisions.", "quote": "Strong legal foundations give teams the confidence to move fast and safely." },
        { "role": "Data Center Engineer", "description": "Manages data center deployment and lifecycle operations, focusing on power, cooling, uptime, and infrastructure reliability.", "quote": "Reliability is designed in advance, not fixed after downtime." }
      ]
    },
    academy: {
      kicker: "Learn with Sanaya",
      title: "Academy",
      intro: "Practical video learning for the platforms and systems your team uses every day.",
      pace: "Learn at your pace",
      paceText: "Videos, notes, and useful resources in one place.",
      loading: "Loading Academy...",
      loadError: "Academy could not be loaded.",
      comingSoon: "Courses are coming soon",
      comingSoonText: "Published Academy content will appear here.",
      sectionsLabel: "Academy sections",
      section: "Section",
      playlist: "playlist",
      playlists: "playlists",
      sectionSoon: "Playlists for this section are coming soon.",
      videos: "videos",
      lessonNotes: "Lesson notes",
      resources: "Resources",
      videosSoon: "Videos for this playlist are coming soon.",
      nowLearning: "Now learning",
      lesson: "Lesson"
    },
    serviceDetail: {
      notFound: "Service not found",
      heroTitle: "Modern delivery for organizations that need technology to perform, not just exist.",
      structured: "Structured delivery",
      structuredText: "Every engagement is shaped around scope clarity, execution quality, and outcomes that matter to operations.",
      businessFit: "Business fit",
      businessFitText: "We focus on workflow improvement, resilience, visibility, and long-term maintainability.",
      capability: "Capability System",
      capabilityTitle: "Key features presented as a clear service architecture instead of a generic checklist.",
      capabilityText: "These are the areas where Sanaya creates practical business impact inside this solution line.",
      insight: "Further Insight",
      insightTitle: "Strategic details that help define fit, growth path, and deployment approach.",
      insightText: "These supporting notes explain why the service matters operationally, not just functionally.",
      next: "Next Step",
      ready: "Ready to move forward with {{service}}?"
    },
    software: {
      kicker: "Software Engineering",
      title: "Applications and internal platforms built like operational infrastructure.",
      intro: "Sanaya’s software team delivers modern digital products with product thinking, scalable architecture, and production-ready execution. We build systems meant to survive real usage, real teams, and real growth.",
      start: "Start a software project",
      scope: "Web apps, internal systems, APIs, and platform delivery",
      production: "Production-minded",
      productionText: "Maintainable code, release readiness, and operational clarity are part of the build from the start.",
      business: "Business-facing",
      businessText: "The output is not just code. It is a clearer workflow, a usable product, or a stronger internal system.",
      system: "Engineering System",
      systemTitle: "We treat delivery as a system, not a sequence of disconnected tasks.",
      systemText: "Good software is the result of aligned decisions across product scope, UX, architecture, quality, and release operations.",
      pillars: [
        { "title": "Product Engineering", "text": "Web platforms, internal systems, and customer-facing products designed for scale and usability." },
        { "title": "Platform Architecture", "text": "Reliable APIs, service boundaries, release workflows, and operational visibility from day one." },
        { "title": "Secure Delivery", "text": "Testing, permissions, review discipline, and production hardening built into the workflow." }
      ],
      chaptersLabel: "Delivery Chapters",
      chaptersTitle: "A software engagement should feel deliberate at every stage.",
      chapters: ["Problem framing and product scope", "Interface and architecture design", "Implementation and integrations", "Release, support, and iteration"],
      stack: "Tech Stack",
      stackTitle: "Modern tools, selected for maintainability and actual business fit.",
      stackText: "We support product builds, ERP extensions, workflow systems, customer portals, and internal operational tools with the same engineering standards.",
      capabilitiesLabel: "Capabilities",
      capabilitiesTitle: "Engineering depth across interface, backend, infrastructure, and release operations.",
      capabilities: [
        { "title": "Frontend systems", "description": "Responsive interfaces, design systems, dashboards, and workflow-heavy web applications." },
        { "title": "Backend services", "description": "APIs, business logic, integrations, and data design built for maintainability." },
        { "title": "DevOps and release", "description": "Containerization, CI/CD, cloud environments, and delivery pipelines that keep teams moving." },
        { "title": "Engineering operations", "description": "Version control, branching strategy, issue tracking, and measurable release discipline." }
      ],
      build: "Build With Sanaya",
      buildTitle: "Need a customer-facing product, internal system, or ERP-connected workflow platform?",
      talk: "Talk to our engineering team"
    },
    dataCenter: {
      kicker: "Data Centers",
      title: "Infrastructure architecture for organizations that cannot afford downtime.",
      description: "Modern organizations require secure, scalable, high-performance data centers that support continuity and growth. Sanaya delivers on-premises, cloud, hyper-converged, edge, and high-speed networking environments tailored to enterprise and government needs.",
      discuss: "Discuss your infrastructure",
      scope: "Enterprise, government, and distributed-site delivery",
      signals: [{ "label": "Built for", "value": "Mission-critical uptime" }, { "label": "Coverage", "value": "Facility + edge environments" }, { "label": "Scope", "value": "Power, cooling, security, cabling" }],
      facility: "Facility systems",
      facilityText: "Critical infrastructure is delivered as a coordinated environment, not as disconnected products.",
      continuity: "Operational continuity",
      continuityText: "We design around uptime, maintainability, and clean expansion paths as needs grow.",
      architecture: "System Architecture",
      architectureTitle: "The data center only works when every layer supports the others.",
      architectureText: "Power, cooling, fire response, surveillance, cabling, and growth planning must be designed like one operating system for the building.",
      lanes: [
        { "title": "Power resilience", "text": "ATS, UPS, and continuity planning that keep workloads stable during disruption." },
        { "title": "Environmental control", "text": "Precision cooling and environmental monitoring tuned for equipment longevity." },
        { "title": "Physical security", "text": "Surveillance, access awareness, fire response, and emergency systems working together." },
        { "title": "Growth model", "text": "Fixed, modular, micro, and mobile footprints that match operational realities." }
      ],
      overview: "Overview",
      overviewTitle: "High-performance environments shaped for reliability and practical expansion.",
      overviewText: "Sanaya supports on-premises builds, edge deployments, modular growth paths, and specialized environments that need fast implementation without sacrificing resilience or manageability.",
      overviewPoints: ["Compute, storage, and physical systems are planned together.", "Delivery models flex based on facility constraints and timeline.", "Long-term serviceability is treated as part of the initial design."],
      imageAlt: "Data center infrastructure {{number}}",
      core: "Core Systems",
      coreTitle: "Mission-critical components presented as a complete operating environment.",
      coreText: "These systems convert a room of equipment into a dependable production environment.",
      features: [
        { "title": "FM200 Fire Suppression", "description": "Fast-acting suppression that protects critical equipment without damaging sensitive infrastructure." },
        { "title": "Fire Alarm System", "description": "Advanced detection and alarm layers that reduce response time and help preserve uptime." },
        { "title": "CCTV Surveillance", "description": "24/7 high-resolution monitoring across sensitive access points and rooms." },
        { "title": "Intrusion Detection", "description": "Unauthorized access detection and perimeter awareness for stronger physical security." },
        { "title": "PAVA System", "description": "Emergency communication and evacuation support with facility-wide broadcast capability." },
        { "title": "Automatic Transfer Switch", "description": "Seamless transition between primary and backup power during outages." },
        { "title": "UPS", "description": "Continuous power for critical systems with protection from outages and fluctuations." },
        { "title": "Precision Cooling", "description": "Controlled thermal performance that extends equipment reliability." },
        { "title": "Environmental Monitoring", "description": "Real-time tracking of temperature, humidity, and room conditions." },
        { "title": "High-Speed Fiber", "description": "Fast, resilient data movement through optimized optical connectivity." },
        { "title": "Structured Copper Cabling", "description": "Reliable copper infrastructure for network and voice transport." },
        { "title": "Racks and Accessories", "description": "Optimized racks, cable management, and hardware organization." }
      ],
      models: "Deployment Models",
      modelsTitle: "Multiple ways to deploy modern capacity based on how your operation runs.",
      modelFit: "Best when the business needs a deployment model that matches real site, budget, and growth constraints.",
      modelItems: [
        { "title": "Fixed Data Centers", "description": "Dedicated facilities that centralize compute, storage, and networking in controlled environments for strong governance and predictable uptime." },
        { "title": "Micro Data Centers", "description": "Compact environments that bring local processing and storage closer to remote, industrial, and distributed sites." },
        { "title": "Modular Data Centers", "description": "Pre-engineered units that accelerate deployment and allow phased capacity growth." },
        { "title": "Mobile Data Centers", "description": "Portable containerized facilities for remote, temporary, or rapidly changing environments." }
      ],
      strategy: "Infrastructure Strategy",
      strategyTitle: "Planning a new facility, an edge site, or a phased capacity expansion?",
      talk: "Talk to Sanaya",
      closeImage: "Close image",
      expandedAlt: "Expanded infrastructure view"
    },
    fire: {
      closePdf: "Close PDF",
      pdfUnsupported: "Your browser does not support inline PDFs.",
      openDocument: "Open the document",
      kicker: "Fire Alarm Systems",
      title: "Fire safety systems designed like operational infrastructure, not just hardware packages.",
      intro: "With Teknim, Sanaya delivers addressable, conventional, wireless, and monitoring-ready fire alarm solutions for reliable detection, fast response, and long-term manageability.",
      scope: "Design, supply, deployment, and monitoring support",
      imageAlt: "Fire alarm systems",
      value: "System Value",
      valueTitle: "Safety systems must be dependable in the moment that matters most.",
      valueText: "The real value is clarity, response speed, compliance readiness, and easier long-term operation, not detection alone.",
      benefits: [
        { "title": "Faster incident response", "text": "Device-level visibility and centralized alerts help teams act with less confusion during critical events." },
        { "title": "Flexible deployment strategy", "text": "Wired, wireless, and hybrid layouts adapt to building conditions and phased rollout constraints." },
        { "title": "Operational continuity", "text": "Monitoring software and dependable architecture support compliance and reduce downtime risk." }
      ],
      lines: "Solution Lines",
      linesTitle: "A complete portfolio from field devices to monitoring software.",
      linesText: "Each solution includes technical documentation so your team can evaluate fit, deployment model, and capability.",
      features: [
        { "title": "Intelligent Addressable Systems", "desc": "FLASHLINK-powered panels with device-level monitoring, network scalability, and centralized control." },
        { "title": "Conventional Fire Alarm Systems", "desc": "Cost-effective and dependable detection for smaller facilities and straightforward layouts." },
        { "title": "Wireless and Hybrid Deployments", "desc": "Mesh-based wireless detection for difficult-to-cable spaces, extensions, and retrofits." },
        { "title": "Monitoring and Response Software", "desc": "Central dashboards, map visibility, remote commands, and real-time operational awareness." }
      ],
      design: "Design Lens",
      designTitle: "The right system starts with the site, not the brochure.",
      designText: "Retrofit complexity, floor coverage, wiring, evacuation, and monitoring expectations shape the final design. Sanaya treats this as an engineered safety project.",
      faqs: [
        { "q": "How do I choose between addressable and conventional systems?", "a": "Addressable systems suit larger complex sites because events trace to specific devices. Conventional systems often suit smaller spaces where budget and simplicity matter." },
        { "q": "Can wired and wireless devices be combined?", "a": "Yes. Hybrid layouts use wireless components in difficult areas and wired loops where practical." },
        { "q": "Do you support remote monitoring?", "a": "Yes. Monitoring software can show alarms, device states, and response actions in centralized interfaces." },
        { "q": "What facilities are these systems suited for?", "a": "Commercial buildings, hospitality, industrial sites, campuses, and multi-zone environments can all be covered with the right design." }
      ],
      consultation: "Safety Consultation",
      consultationTitle: "Planning a new facility, extension, or compliance-focused upgrade?"
    }
  },
  ar: {
    common: {
      languageLabel: "التبديل إلى الإنجليزية",
      whatsappLabel: "التواصل عبر واتساب",
      learnMore: "اعرف المزيد",
      contactSanaya: "تواصل مع السنايا",
      download: "تنزيل",
      viewCatalog: "عرض الكتالوج"
    },
    nav: {
      odooPlans: "باقات إعداد Odoo",
      home: "الرئيسية",
      about: "عن الشركة",
      partners: "الشركاء",
      solutions: "الحلول",
      services: "الخدمات",
      team: "فريقنا",
      academy: "الأكاديمية",
      packages: "الباقات",
      contact: "اتصل بنا",
      products: "المنتجات",
      portal: "البوابة",
      profile: "الملف التعريفي 2026",
      downloadProfile: "تنزيل الملف التعريفي 2026",
      supportCta: "دعم Odoo",
      support: "الدعم",
      homeLabel: "الانتقال إلى الصفحة الرئيسية",
      menuLabel: "فتح أو إغلاق القائمة"
    },
    landing: {
      badge: "شركة تقنية مقرها بغداد",
      title: "نبني",
      titleAccent: "البنية التحتية للأعمال الحديثة.",
      intro: "تصمم السنايا العربية الأنظمة التقنية الحيوية للمؤسسات الطموحة وتؤمنها وتشغلها. نجمع مراكز البيانات والبرمجيات والشبكات وأنظمة السلامة وOdoo ضمن شريك تنفيذ واحد.",
      explore: "استكشف الحلول",
      consultation: "احجز استشارة",
      trustItems: ["مراكز البيانات", "هندسة البرمجيات", "أمن البنية التحتية", "التحول عبر Odoo"],
      snapshot: "لمحة عن التنفيذ",
      snapshotTitle: "شريك واحد للتقنيات الحيوية",
      active: "متاح",
      stats: ["تنفيذ بمستوى المؤسسات", "بنية رقمية متكاملة", "بيئات تقنية قابلة للتوسع"],
      architecture: "يبدأ التحول التقني من المعمارية الصحيحة.",
      scale: "من البنية التحتية المادية إلى برمجيات الأعمال، تصمم السنايا أنظمة تتوسع بثبات."
    },
    about: {
      imageAlt: "مكتب السنايا والبنية التحتية التقنية",
      imageKicker: "مصممة للبيئات الحيوية",
      imageText: "نساعد المؤسسات على التحديث ببنية تحتية مرنة وأنظمة ذكية وفرق تنفيذ تفهم المخاطر التشغيلية.",
      kicker: "عن السنايا",
      title: "شركة تقنية تركز على الأنظمة التي يعتمد عليها عملك كل يوم.",
      intro: "نقدم في السنايا العربية البنية التحتية والتطبيقات والخدمات الاستشارية التي تحافظ على أمن المؤسسات واتصالها واستعدادها للنمو. يشمل عملنا مرافق المؤسسات والمنصات الرقمية والدعم الحيوي.",
      metrics: [
        { "label": "التركيز", "value": "تقنيات المؤسسات" },
        { "label": "التغطية", "value": "من البنية إلى التطبيقات" },
        { "label": "المنهج", "value": "نستشير ونبني وندعم" }
      ],
      highlights: ["فرق تقنية معتمدة ومتخصصة", "تنفيذ متكامل من الاستراتيجية إلى التشغيل", "البنية والأمن والبرمجيات تحت سقف واحد"],
      capabilities: [
        { "title": "تنفيذ متكامل", "text": "نربط المرافق والشبكات وأنظمة الأمن والبرمجيات ضمن بيئة تشغيلية واحدة." },
        { "title": "تفكير مبني على الحلول", "text": "نصمم كل مشروع حول استمرارية الأعمال وقابلية التوسع والأداء القابل للقياس." },
        { "title": "تنفيذ سريع", "text": "تنتقل فرقنا من التقييم إلى التنفيذ بمسؤوليات واضحة وأقل قدر من التعقيد." }
      ]
    },
    mission: {
      vision: "الرؤية",
      visionTitle: "رفع مستوى تنفيذ الحلول التقنية في العراق والمنطقة.",
      visionText: "نطمح لأن نكون الخيار الأول للمؤسسات التي تحتاج إلى بنية حديثة وأنظمة موثوقة وابتكار عملي يحسن التشغيل الفعلي.",
      mission: "الرسالة",
      missionTitle: "تمكين العملاء بالإرشاد الخبير والأنظمة الحديثة والتنفيذ المسؤول.",
      missionText: "مهمتنا تقديم المزيج المناسب من الاستشارات والهندسة والمنتجات والدعم ليتمكن العملاء من اتخاذ قرارات تقنية واثقة وتنفيذها بإتقان.",
      principles: [
        { "title": "الموثوقية أولاً", "text": "نعطي الأولوية للاستمرارية والمرونة والثقة التشغيلية في كل نظام نقدمه." },
        { "title": "شراكة مع العميل", "text": "هدفنا أن نكون الفريق الذي يثق به العملاء عندما يكون العمل معقداً والمسؤولية كبيرة." }
      ]
    },
    solutions: {
      kicker: "الحلول الأساسية",
      title: "قدرات تقنية مصممة بعقلية شركة حلول حديثة، لا كقائمة منتجات.",
      intro: "نركز على الأنظمة المؤثرة في الاستمرارية والأمن وكفاءة سير العمل والنمو الرقمي، ونقدم كل حل مع الاستشارة والتنفيذ والدعم طويل الأمد.",
      solution: "الحل",
      details: "عرض تفاصيل الحل",
      items: [
        { "title": "أنظمة Odoo ERP", "description": "ننفذ بيئات Odoo مصممة لتوحيد المالية والموارد البشرية والعمليات والمبيعات والخدمات ضمن منصة أعمال واحدة قابلة للتوسع." },
        { "title": "مراكز البيانات", "description": "تصمم السنايا مراكز بيانات مرنة وتنفذها مع استمرارية الطاقة والتبريد المتقدم والأمن المادي ومعمارية تركز على الأداء." },
        { "title": "أنظمة إنذار الحريق", "description": "أنظمة معنونة ولاسلكية ومتكاملة للمراقبة، مصممة للاستجابة السريعة والامتثال والحماية الموثوقة للمرافق." },
        { "title": "هندسة البرمجيات", "description": "نبني تطبيقات الويب والهاتف والمنصات الداخلية والأدوات التشغيلية التي تضيف الموثوقية والسرعة والوضوح لسير العمل." },
        { "title": "الشبكات والأمن", "description": "من المحولات والشبكات اللاسلكية إلى حماية المحيط وسياسات الأجهزة، نبني اتصالاً آمناً للمؤسسات والمواقع الحيوية." },
        { "title": "أمن منشآت النفط والغاز", "description": "أنظمة Hikvision متكاملة للأمن والصحة والسلامة والبيئة في الحقول وخطوط الأنابيب والمصافي ومواقع التشغيل البعيدة." },
        { "title": "السلامة من الحريق مع HikFire", "description": "حلول مترابطة للكشف عن الحريق والإنذار والتحقق بالفيديو وإدارة الطوارئ في المباني والمواقع الصناعية." }
      ]
    },
    consulting: {
      kicker: "نموذج الخدمة",
      title: "لا نتوقف عند المنتجات، بل نرافقك في التخطيط والتنفيذ والدعم.",
      intro: "نساعد في تحديد الخطة وتنفيذ العمل ونبقى مسؤولين بعد الإطلاق.",
      items: [
        { "title": "الخدمات الاستشارية", "description": "تقييمات وتخطيط معماري وخرائط طريق تقنية توائم الاستثمار مع أولويات العمل." },
        { "title": "خدمات الدعم", "description": "دعم تشغيلي للبيئات الحيوية مع استجابة سريعة ومعالجة المشكلات والتحسين المستمر." },
        { "title": "خدمات التنفيذ", "description": "تنفيذ ميداني وعن بُعد لعمليات الإطلاق والترحيل والتكامل والتسليم الجاهز للإنتاج." }
      ]
    },
    partners: {
      kicker: "الشركاء الاستراتيجيون",
      title: "شراكات تقنية موثوقة في البنية التحتية والأمن والاتصالات وأنظمة المؤسسات.",
      intro: "تتيح لنا منظومة الموردين بناء حلول على منصات مجربة مع إبقاء التنفيذ موحداً من خلال فريق واحد.",
      categories: ["مراكز البيانات والطاقة", "السلامة من الحريق", "الكوابل الهيكلية", "المراقبة والأنظمة الذكية", "أنظمة الاتصالات", "أمن الشبكات"]
    },
    contact: {
      labels: { "email": "البريد الإلكتروني", "phone": "الهاتف", "whatsapp": "واتساب", "office": "المكتب" },
      chat: "تحدث مع فريقنا",
      kicker: "اتصل بنا",
      title: "لنبدأ المرحلة التالية من منظومتك التقنية.",
      intro: "تواصل معنا لمشاريع البنية التحتية أو البرمجيات أو التحول الرقمي أو الدعم طويل الأمد، وسنساعدك في تحديد الخطوة المناسبة.",
      address: "الطابق السادس، بناية المسار، شارع الصناعة، بغداد، العراق",
      formTitle: "ابدأ المحادثة",
      formIntro: "أخبرنا بما تبنيه أو تطوره أو تصلحه، وسنرد عليك بالفريق والخطوة المناسبة.",
      name: "الاسم",
      namePlaceholder: "كيف يمكننا مخاطبتك؟",
      email: "البريد الإلكتروني للعمل",
      message: "ملخص المشروع",
      messagePlaceholder: "أخبرنا عن التحدي أو الجدول الزمني أو النظام الذي تريد تطويره.",
      submit: "إرسال الرسالة",
      success: "تم إرسال رسالتك بنجاح.",
      required: "جميع الحقول مطلوبة.",
      failed: "تعذر إرسال الرسالة. حاول مرة أخرى."
    },
    footer: {
      text: "تبني السنايا العربية أنظمة تقنية للمؤسسات تشمل البنية التحتية والبرمجيات والأمن والدعم."
    },
    team: {
      ticker: ["نبني أنظمة موثوقة", "الهندسة + البنية التحتية + العمليات", "تنفيذ يركز على العميل"],
      kicker: "تعرف على فريق السنايا",
      intro: "قيادة وهندسة وعمليات تعمل معاً لتقديم أنظمة موثوقة ونتائج قابلة للقياس.",
      tags: ["البنية التحتية", "مراكز البيانات", "هندسة البرمجيات", "Odoo", "الدعم والتنفيذ"],
      title: "فريقنا",
      members: [
        { "role": "الرئيس التنفيذي", "description": "يحدد توجه الشركة ويقود الشراكات الاستراتيجية ويضمن أن تحقق المبادرات الرئيسية قيمة أعمال قابلة للقياس.", "quote": "وضوح المسؤولية والمراحل القابلة للقياس هما أساس توسع الفرق الناجحة." },
        { "role": "المدير التقني", "description": "يقود خارطة الطريق التقنية ومعايير المعمارية وجودة الهندسة في البرمجيات والبنية التحتية والتكاملات.", "quote": "يجب أن تقلل القرارات التقنية تعقيد اليوم وتفتح خيارات الغد." },
        { "role": "مدير فرع البصرة", "description": "يقود عمليات البصرة وينسق تنفيذ المشاريع المحلية ويحافظ على تواصل قوي مع العملاء وثبات مستوى الخدمة.", "quote": "التنفيذ المحلي القوي يقوم على الانضباط والتواصل والثقة." },
        { "role": "مهندس البرمجيات الرئيسي ومعماري المنتجات", "description": "مهندس برمجيات رئيسي ومدير مشاريع برمجية وبحث وتطوير ومستشار وظيفي معتمد لنظام Odoo v19 | بكالوريوس هندسة حاسوب", "quote": "يمكن تنفيذها، لكن هل تقع ضمن نطاق عملك؟" },
        { "role": "مهندس شبكات", "description": "يبني بيئات شبكية آمنة وعالية التوافر ويحافظ عليها لعمليات المؤسسات ومراكز البيانات.", "quote": "أفضل شبكة مستقرة هي التي لا تشعر بها، مع أنها حيوية في كل لحظة." },
        { "role": "مهندس تقنية معلومات وبنية تحتية", "description": "يحافظ على أنظمة تقنية المعلومات الأساسية ويدعم نشر البنية التحتية ويضمن استمرارية الأعمال اليومية بأمان.", "quote": "البنية التحتية الموثوقة هي الأساس الذي يمكّن كل فريق من التحرك أسرع." },
        { "role": "مصممة جرافيك ومتخصصة تسويق", "description": "تصمم الهوية والمواد الإعلانية والمحتوى الرقمي الذي يعزز حضور السنايا عبر قنوات التسويق.", "quote": "التصميم الجيد يوصل القيمة قبل قراءة أول كلمة." },
        { "role": "مديرة منتجات", "description": "تحول احتياجات العمل إلى متطلبات منتجات واضحة وتوحد أولويات الفرق وتحافظ على تركيز التنفيذ على أثر المستخدم.", "quote": "تأتي المنتجات الرائعة من الاستماع بعناية والتنفيذ بهدف واضح." },
        { "role": "محامية", "description": "تقدم الإرشاد القانوني في العقود والامتثال والمخاطر لحماية العمليات ودعم قرارات الأعمال الواثقة.", "quote": "الأسس القانونية القوية تمنح الفرق الثقة للتحرك بسرعة وأمان." },
        { "role": "مهندس مراكز بيانات", "description": "يدير تنفيذ مراكز البيانات ودورة حياتها مع التركيز على الطاقة والتبريد والاستمرارية وموثوقية البنية التحتية.", "quote": "تُصمم الموثوقية مسبقاً، ولا تُصلح بعد التوقف." }
      ]
    },
    academy: {
      kicker: "تعلم مع السنايا",
      title: "الأكاديمية",
      intro: "تعلم عملي بالفيديو للمنصات والأنظمة التي يستخدمها فريقك كل يوم.",
      pace: "تعلم بالسرعة التي تناسبك",
      paceText: "فيديوهات وملاحظات وموارد مفيدة في مكان واحد.",
      loading: "جارٍ تحميل الأكاديمية...",
      loadError: "تعذر تحميل الأكاديمية.",
      comingSoon: "الدورات قادمة قريباً",
      comingSoonText: "سيظهر هنا محتوى الأكاديمية المنشور.",
      sectionsLabel: "أقسام الأكاديمية",
      section: "القسم",
      playlist: "قائمة تشغيل",
      playlists: "قوائم تشغيل",
      sectionSoon: "قوائم التشغيل لهذا القسم قادمة قريباً.",
      videos: "فيديو",
      lessonNotes: "ملاحظات الدرس",
      resources: "الموارد",
      videosSoon: "فيديوهات قائمة التشغيل هذه قادمة قريباً.",
      nowLearning: "تتعلم الآن",
      lesson: "الدرس"
    },
    serviceDetail: {
      notFound: "الخدمة غير موجودة",
      heroTitle: "تنفيذ حديث للمؤسسات التي تحتاج إلى تقنية تعمل بكفاءة، لا أن تكون موجودة فقط.",
      structured: "تنفيذ منظم",
      structuredText: "نصمم كل مشروع حول وضوح النطاق وجودة التنفيذ والنتائج المؤثرة في العمليات.",
      businessFit: "ملاءمة العمل",
      businessFitText: "نركز على تحسين سير العمل والمرونة والوضوح وسهولة الصيانة على المدى الطويل.",
      capability: "منظومة القدرات",
      capabilityTitle: "خصائص رئيسية ضمن معمارية خدمة واضحة بدلاً من قائمة عامة.",
      capabilityText: "هذه هي المجالات التي تصنع فيها السنايا أثراً عملياً داخل هذا الحل.",
      insight: "تفاصيل إضافية",
      insightTitle: "تفاصيل استراتيجية تساعد في تحديد الملاءمة ومسار النمو وطريقة التنفيذ.",
      insightText: "توضح هذه الملاحظات أهمية الخدمة تشغيلياً، وليس وظيفياً فقط.",
      next: "الخطوة التالية",
      ready: "هل أنت مستعد للبدء بخدمة {{service}}؟",
      services: {
        "deployment-services": {
          "title": "خدمات التنفيذ",
          "description": "تنفذ فرقنا المتخصصة مشاريع البنية التحتية والسحابة والأمن والبرمجيات وفق أفضل الممارسات لضمان تشغيل سلس وآمن وقابل للتوسع يناسب احتياجات العمل.",
          "summary": "تنفيذ يركز على تحويل الخطط والمنصات إلى أنظمة جاهزة للإنتاج.",
          "features": [
            { "title": "تنفيذ البنية التحتية لتقنية المعلومات", "description": "ننفذ الخوادم والتخزين والشبكات ونضبطها للأداء والتوسع." },
            { "title": "تنفيذ السحابة والتكامل", "description": "بيئات سحابية وهجينة لاعتماد سلس وتكامل موثوق." },
            { "title": "تنفيذ حلول الأمن السيبراني", "description": "جدران حماية وأمن أجهزة وضوابط حماية مدروسة." },
            { "title": "تنفيذ مراكز البيانات", "description": "بيئات مؤسسات تراعي الطاقة والتبريد والمرونة التشغيلية." },
            { "title": "تنفيذ أنظمة المراقبة", "description": "أنظمة مراقبة مع تخطيط التغطية والوصول عن بُعد والإعداد التشغيلي." },
            { "title": "تنفيذ البرمجيات والتطبيقات", "description": "إطلاق التطبيقات وتكاملها بأقل تأثير على العمليات." },
            { "title": "تنفيذ الأنظمة الداخلية وERP", "description": "إطلاق أنظمة أعمال تحسن الأتمتة ووضوح سير العمل." },
            { "title": "تنفيذ الشبكات وتحسينها", "description": "شبكات موثوقة مضبوطة للأداء والمرونة والأمن." },
            { "title": "تنفيذ إنترنت الأشياء والأنظمة الذكية", "description": "أنظمة مترابطة للأتمتة والاستشعار والوعي التشغيلي." },
            { "title": "تنفيذ الذكاء الاصطناعي والتعلم الآلي", "description": "تشغيل النماذج الذكية ومسارات البيانات في بيئات العمل." },
            { "title": "أتمتة عمليات الأعمال", "description": "أتمتة تقلل العمل المتكرر وتحسن ثبات العمليات." },
            { "title": "إعداد الخدمات المُدارة", "description": "تأسيس المراقبة والدعم واستمرارية التشغيل." }
          ]
        },
        "consulting-services": {
          "title": "الخدمات الاستشارية",
          "description": "يقدم مستشارونا إرشاداً خبيراً وحلولاً مبتكرة واستراتيجيات مصممة لأهداف العمل، بالاستناد إلى معرفة حديثة وشهادات وخبرة عملية تضمن الكفاءة والأمن والنجاح طويل الأمد.",
          "summary": "استشارات تربط الاستراتيجية والمعمارية بالخطوات العملية التالية.",
          "features": [
            { "title": "استشارات تقنية المعلومات", "description": "إرشاد للبنية التحتية والتحول وخرائط الطريق التقنية." },
            { "title": "استشارات الأمن السيبراني", "description": "توصيات مبنية على المخاطر لتعزيز حماية الأنظمة والمستخدمين." },
            { "title": "الحلول السحابية والترحيل", "description": "تخطيط الاعتماد والترحيل والتحسين للبيئات السحابية." },
            { "title": "مراكز البيانات والبنية التحتية", "description": "دعم معماري للحوسبة والتخزين والمرونة واستراتيجية المرافق." },
            { "title": "حلول المراقبة والكاميرات", "description": "استشارات للأمن المادي والمراقبة واختيار النظام المناسب." },
            { "title": "استشارات تطوير البرمجيات", "description": "صياغة المتطلبات وإرشاد المعمارية وتخطيط البرمجيات." },
            { "title": "استشارات الأنظمة الداخلية وERP", "description": "تخطيط Odoo وCRM والأنظمة التشغيلية لتحسين سير العمل." },
            { "title": "تصميم الشبكات وتحسينها", "description": "تخطيط شبكات للأداء والموثوقية وسهولة الصيانة." },
            { "title": "استشارات إدارة المشاريع", "description": "إرشاد للتنفيذ وهياكل التنسيق ووضوح التسليم." },
            { "title": "إنترنت الأشياء والحلول الذكية", "description": "استشارات للأتمتة والاستشعار والبيئات التشغيلية المترابطة." },
            { "title": "أتمتة عمليات الأعمال", "description": "رسم سير العمل وإعادة تصميمه لإزالة التعقيد والعمل اليدوي." },
            { "title": "استشارات الذكاء الاصطناعي", "description": "إرشاد عملي لإدخال الذكاء في عمليات الأعمال." },
            { "title": "دعم تقنية المعلومات والخدمات المُدارة", "description": "استراتيجية دعم ونماذج تشغيل لما بعد الإطلاق." }
          ]
        },
        "support-services": {
          "title": "خدمات الدعم",
          "description": "تحافظ خدمات الدعم على استمرارية عملك من خلال المساعدة السريعة والاستجابة الخبيرة عند الطلب، سواء لاستكشاف مشكلة عاجلة أو صيانة مجدولة أو تدخل تقني مستهدف.",
          "summary": "نماذج دعم موثوقة للفرق التي تحتاج إلى الاستجابة والاستمرارية.",
          "features": [
            { "title": "دعم على مدار الساعة", "description": "مساعدة مستمرة للمشكلات الحيوية وتقليل التوقف وضمان استمرارية الأعمال." },
            { "title": "خدمات عند الاتصال", "description": "خبراء متاحون عندما تحتاج الأنظمة إلى تدخل أو تصعيد فوري." },
            { "title": "دعم عند الطلب", "description": "استكشاف مرن للمشكلات وتحديثات وتحسين وتدخل مستهدف." }
          ]
        },
        "odoo-erp-system": {
          "title": "نظام Odoo ERP",
          "description": "Odoo منصة متكاملة لإدارة الأعمال توحد المحاسبة والمخزون والمبيعات والموارد البشرية والمشاريع ضمن نظام معياري قابل للتخصيص، مع أتمتة وبيانات فورية وتكامل سلس بين الأقسام.",
          "summary": "طبقة تشغيل ERP مترابطة للمالية والعمليات والمبيعات والموارد البشرية والنمو.",
          "features": [
            { "title": "هيكل معياري", "description": "اختر التطبيقات التي تحتاجها وتوسع بمرور الوقت." },
            { "title": "واجهة سهلة الاستخدام", "description": "لوحات واضحة وسير عمل بديهي يقلل صعوبة التدريب." },
            { "title": "نظام متكامل", "description": "وحدات مترابطة تلغي العزلة وتحسن وضوح العمليات." },
            { "title": "قابلية التوسع", "description": "نموذج ينمو من احتياجات الشركات الصغيرة إلى تعقيد المؤسسات." },
            { "title": "قابلية التخصيص", "description": "إعدادات وامتدادات مرنة تناسب نموذج عملك." },
            { "title": "الأتمتة والذكاء الاصطناعي", "description": "أتمتة سير العمل ورؤية تشغيلية أذكى بين الأقسام." },
            { "title": "السحابة أو الخادم الخاص", "description": "اختر نموذج النشر الأنسب للحوكمة والبنية التحتية." },
            { "title": "شركات وعملات متعددة", "description": "دعم التعقيد الإقليمي والتنظيمي في بيئة واحدة." },
            { "title": "التقارير والتحليلات", "description": "لوحات فورية تساعد الإدارة على العمل ببيانات موثوقة." },
            { "title": "التجارة الإلكترونية وبناء المواقع", "description": "بيع رقمي متكامل مرتبط بالمخزون والمعاملات." },
            { "title": "المحاسبة والمالية", "description": "ضوابط للفوترة والمطابقة والعمليات المالية." },
            { "title": "الموارد البشرية والرواتب", "description": "إدارة الموظفين والحضور والرواتب ضمن نظام مترابط." },
            { "title": "المخزون والمستودعات", "description": "تتبع مباشر للمخزون وتحكم تشغيلي بين المستودعات." },
            { "title": "CRM والمبيعات", "description": "إدارة العملاء المحتملين ومسار المبيعات وعلاقات العملاء." },
            { "title": "التصنيع وMRP", "description": "تخطيط الإنتاج والتحكم التشغيلي للشركات الصناعية." },
            { "title": "إدارة المشاريع والمهام", "description": "تنفيذ تعاوني بمسؤوليات ووضوح أفضل." }
          ],
          "additionalInfo": [
            { "title": "معياري بطبيعته", "description": "يساعد الهيكل المعياري الشركات على البدء بالحجم المناسب والتوسع عندما تبرر الحاجة التشغيلية ذلك." },
            { "title": "إنتاجية عبر سهولة الاستخدام", "description": "تقلل الواجهة الواضحة واللوحات القابلة للضبط صعوبة التعلم وتسرع اعتماد النظام." },
            { "title": "عمليات متكاملة", "description": "تتحرك بيانات المبيعات والمالية والموارد والمخزون والمشاريع في بيئة واحدة." },
            { "title": "قابل للتوسع والتخصيص", "description": "يتكيف النظام مع النمو والتخصص عبر الوحدات وسير العمل المخصص ومرونة النشر." }
          ]
        },
        "networking-security-solutions": {
          "title": "حلول الشبكات والأمن",
          "description": "توفر السنايا حلولاً متقدمة لحماية الأعمال من التهديدات والوصول غير المصرح به وتسرب البيانات، تشمل الجدران النارية ومنع الاختراق وحماية الأجهزة والمراقبة الفورية ضمن معمارية قابلة للتوسع.",
          "summary": "معمارية اتصال آمن للبيئات الحديثة الهجينة والموزعة.",
          "features": [
            { "title": "الشبكات المعرفة برمجياً", "description": "تحكم مركزي وإدارة سياسات لشبكات أكثر مرونة." },
            { "title": "شبكات مراكز البيانات", "description": "اتصال عالي السرعة للخوادم والتخزين والتطبيقات." },
            { "title": "بنية WAN وLAN", "description": "أسس اتصال موثوقة بين المواقع وداخل المباني." },
            { "title": "الحلول اللاسلكية", "description": "وصول لاسلكي آمن ومرن لبيئات العمل الحديثة." },
            { "title": "مراقبة الشبكات وإدارتها", "description": "وضوح وتحكم بالإعدادات ومعالجة استباقية للمشكلات." },
            { "title": "حماية الأجهزة", "description": "ضوابط تحمي الأجهزة والعاملين عن بُعد من المخاطر." },
            { "title": "نسيج أمني متكامل", "description": "تنسيق واستجابة أمنية عبر طبقات الحماية المختلفة." }
          ],
          "additionalInfo": [
            { "title": "الرؤية والتحكم", "description": "يعتمد أمن الشبكات الحديث على الرؤية المركزية وثبات السياسات واكتشاف الحالات غير الطبيعية مبكراً." },
            { "title": "مصمم للبيئات الهجينة", "description": "يجب تأمين المستخدمين والفروع والسحابة ومراكز البيانات كمنظومة مترابطة واحدة." },
            { "title": "حماية قابلة للتوسع", "description": "من الاتصال اللاسلكي وأمن الأجهزة إلى التقسيم والجدران النارية، يجب أن تنمو المعمارية مع العمل." }
          ]
        }
      }
    },
    software: {
      kicker: "هندسة البرمجيات",
      title: "تطبيقات ومنصات داخلية مبنية كبنية تشغيلية موثوقة.",
      intro: "يقدم فريق السنايا منتجات رقمية حديثة بتفكير منتجي ومعمارية قابلة للتوسع وتنفيذ جاهز للإنتاج، لأنظمتنا أن تعمل مع الاستخدام والفرق والنمو الحقيقي.",
      start: "ابدأ مشروعاً برمجياً",
      scope: "تطبيقات ويب وأنظمة داخلية وواجهات API وتنفيذ منصات",
      production: "بعقلية الإنتاج",
      productionText: "تدخل قابلية الصيانة والاستعداد للإطلاق والوضوح التشغيلي في البناء منذ البداية.",
      business: "موجه للأعمال",
      businessText: "النتيجة ليست شيفرة فقط، بل سير عمل أوضح أو منتج قابل للاستخدام أو نظام داخلي أقوى.",
      system: "منظومة الهندسة",
      systemTitle: "نتعامل مع التنفيذ كمنظومة، لا كسلسلة مهام منفصلة.",
      systemText: "البرمجيات الجيدة نتيجة قرارات متوافقة في نطاق المنتج وتجربة المستخدم والمعمارية والجودة والإطلاق.",
      pillars: [
        { "title": "هندسة المنتجات", "text": "منصات ويب وأنظمة داخلية ومنتجات للعملاء مصممة للتوسع وسهولة الاستخدام." },
        { "title": "معمارية المنصات", "text": "واجهات API موثوقة وحدود خدمات وسير إطلاق ورؤية تشغيلية منذ اليوم الأول." },
        { "title": "تنفيذ آمن", "text": "اختبارات وصلاحيات ومراجعة وتقوية للإنتاج مدمجة في سير العمل." }
      ],
      chaptersLabel: "مراحل التنفيذ",
      chaptersTitle: "يجب أن يكون المشروع البرمجي مدروساً في كل مرحلة.",
      chapters: ["تحديد المشكلة ونطاق المنتج", "تصميم الواجهة والمعمارية", "التنفيذ والتكاملات", "الإطلاق والدعم والتحسين"],
      stack: "التقنيات",
      stackTitle: "أدوات حديثة نختارها لقابلية الصيانة وملاءمة العمل.",
      stackText: "ندعم بناء المنتجات وامتدادات Odoo وأنظمة سير العمل وبوابات العملاء والأدوات التشغيلية الداخلية بالمعايير الهندسية نفسها.",
      capabilitiesLabel: "القدرات",
      capabilitiesTitle: "عمق هندسي في الواجهات والخلفية والبنية التحتية وعمليات الإطلاق.",
      capabilities: [
        { "title": "أنظمة الواجهة", "description": "واجهات متجاوبة وأنظمة تصميم ولوحات وتطبيقات ويب كثيفة سير العمل." },
        { "title": "خدمات الخلفية", "description": "واجهات API ومنطق أعمال وتكاملات وتصميم بيانات قابل للصيانة." },
        { "title": "DevOps والإطلاق", "description": "حاويات وCI/CD وبيئات سحابية ومسارات تنفيذ تحافظ على سرعة الفرق." },
        { "title": "عمليات الهندسة", "description": "إدارة الإصدارات واستراتيجية الفروع وتتبع المشكلات وانضباط الإطلاق." }
      ],
      build: "ابنِ مع السنايا",
      buildTitle: "هل تحتاج إلى منتج للعملاء أو نظام داخلي أو منصة سير عمل مرتبطة بـOdoo؟",
      talk: "تحدث مع فريق الهندسة"
    },
    dataCenter: {
      kicker: "مراكز البيانات",
      title: "معمارية بنية تحتية للمؤسسات التي لا تحتمل التوقف.",
      description: "تحتاج المؤسسات الحديثة إلى مراكز بيانات آمنة وقابلة للتوسع وعالية الأداء تدعم الاستمرارية والنمو. تقدم السنايا بيئات داخلية وسحابية ومدمجة وطرفية وشبكات عالية السرعة مصممة لاحتياجات المؤسسات والجهات الحكومية.",
      discuss: "ناقش احتياجات البنية التحتية",
      scope: "تنفيذ للمؤسسات والحكومة والمواقع الموزعة",
      signals: [{ "label": "مصممة لـ", "value": "استمرارية الأنظمة الحيوية" }, { "label": "التغطية", "value": "المرافق والبيئات الطرفية" }, { "label": "النطاق", "value": "الطاقة والتبريد والأمن والكوابل" }],
      facility: "أنظمة المرافق",
      facilityText: "نقدم البنية الحيوية كبيئة منسقة، لا كمنتجات منفصلة.",
      continuity: "الاستمرارية التشغيلية",
      continuityText: "نصمم للاستمرارية وسهولة الصيانة ومسارات توسع واضحة.",
      architecture: "معمارية النظام",
      architectureTitle: "يعمل مركز البيانات عندما تدعم كل طبقة الطبقات الأخرى.",
      architectureText: "يجب تصميم الطاقة والتبريد والاستجابة للحريق والمراقبة والكوابل والنمو كمنظومة تشغيل واحدة للمبنى.",
      lanes: [
        { "title": "مرونة الطاقة", "text": "ATS وUPS وتخطيط استمرارية يحافظ على ثبات الأحمال أثناء الاضطراب." },
        { "title": "التحكم البيئي", "text": "تبريد دقيق ومراقبة بيئية تطيل عمر المعدات." },
        { "title": "الأمن المادي", "text": "المراقبة وكشف الدخول والاستجابة للحريق والطوارئ تعمل معاً." },
        { "title": "نموذج النمو", "text": "خيارات ثابتة ومعيارية ومصغرة ومتنقلة تناسب الواقع التشغيلي." }
      ],
      overview: "نظرة عامة",
      overviewTitle: "بيئات عالية الأداء مصممة للموثوقية والتوسع العملي.",
      overviewText: "تدعم السنايا البناء الداخلي والنشر الطرفي والنمو المعياري والبيئات المتخصصة التي تحتاج إلى تنفيذ سريع من دون التضحية بالمرونة أو الإدارة.",
      overviewPoints: ["نخطط الحوسبة والتخزين والأنظمة المادية معاً.", "تتغير نماذج التنفيذ حسب قيود الموقع والوقت.", "ندمج قابلية الصيانة طويلة الأمد في التصميم الأولي."],
      imageAlt: "البنية التحتية لمركز البيانات {{number}}",
      core: "الأنظمة الأساسية",
      coreTitle: "مكونات حيوية ضمن بيئة تشغيل متكاملة.",
      coreText: "تحول هذه الأنظمة غرفة المعدات إلى بيئة إنتاج موثوقة.",
      features: [
        { "title": "إطفاء الحريق FM200", "description": "إطفاء سريع يحمي المعدات من دون إتلاف البنية الحساسة." },
        { "title": "نظام إنذار الحريق", "description": "طبقات كشف وإنذار متقدمة تقلل وقت الاستجابة وتحافظ على الاستمرارية." },
        { "title": "مراقبة CCTV", "description": "مراقبة عالية الدقة على مدار الساعة لنقاط الدخول والغرف الحساسة." },
        { "title": "كشف التسلل", "description": "كشف الوصول غير المصرح به ورفع مستوى التحكم بالأمن المادي." },
        { "title": "نظام PAVA", "description": "اتصالات طوارئ ودعم إخلاء مع بث واضح في كامل المرفق." },
        { "title": "مفتاح التحويل التلقائي", "description": "انتقال سلس بين الطاقة الرئيسية والاحتياطية عند الانقطاع." },
        { "title": "UPS", "description": "طاقة مستمرة للأنظمة الحيوية وحماية من الانقطاع والتذبذب." },
        { "title": "التبريد الدقيق", "description": "أداء حراري مضبوط يطيل موثوقية المعدات." },
        { "title": "المراقبة البيئية", "description": "تتبع فوري للحرارة والرطوبة وظروف الغرفة." },
        { "title": "ألياف عالية السرعة", "description": "نقل بيانات سريع ومرن عبر اتصال بصري محسن." },
        { "title": "كوابل نحاسية هيكلية", "description": "بنية نحاسية موثوقة لنقل الشبكة والصوت." },
        { "title": "الرفوف وملحقاتها", "description": "تنظيم محسن للرفوف والكوابل والمعدات." }
      ],
      models: "نماذج التنفيذ",
      modelsTitle: "طرق متعددة لتنفيذ السعة الحديثة حسب طبيعة عملياتك.",
      modelFit: "مناسب عندما يحتاج العمل إلى نموذج يطابق الموقع والميزانية وقيود النمو.",
      modelItems: [
        { "title": "مراكز بيانات ثابتة", "description": "مرافق مخصصة تجمع الحوسبة والتخزين والشبكات في بيئة مضبوطة للحوكمة والاستمرارية." },
        { "title": "مراكز بيانات مصغرة", "description": "بيئات مدمجة تقرب المعالجة والتخزين من المواقع النائية والصناعية والموزعة." },
        { "title": "مراكز بيانات معيارية", "description": "وحدات مسبقة الهندسة تسرع التنفيذ وتسمح بنمو السعة على مراحل." },
        { "title": "مراكز بيانات متنقلة", "description": "مرافق حاويات محمولة للبيئات النائية أو المؤقتة أو سريعة التغير." }
      ],
      strategy: "استراتيجية البنية التحتية",
      strategyTitle: "هل تخطط لمرفق جديد أو موقع طرفي أو توسع مرحلي؟",
      talk: "تحدث مع السنايا",
      closeImage: "إغلاق الصورة",
      expandedAlt: "عرض موسع للبنية التحتية"
    },
    fire: {
      closePdf: "إغلاق ملف PDF",
      pdfUnsupported: "متصفحك لا يدعم عرض ملفات PDF داخل الصفحة.",
      openDocument: "فتح المستند",
      kicker: "أنظمة إنذار الحريق",
      title: "أنظمة سلامة من الحريق مصممة كبنية تشغيلية، لا كحزم أجهزة فقط.",
      intro: "تقدم السنايا مع Teknim حلول إنذار معنونة وتقليدية ولاسلكية وجاهزة للمراقبة للكشف الموثوق والاستجابة السريعة وسهولة الإدارة.",
      scope: "التصميم والتجهيز والتنفيذ ودعم المراقبة",
      imageAlt: "أنظمة إنذار الحريق",
      value: "قيمة النظام",
      valueTitle: "يجب أن تكون أنظمة السلامة موثوقة في اللحظة الأهم.",
      valueText: "القيمة الحقيقية هي الوضوح وسرعة الاستجابة والاستعداد للامتثال وسهولة التشغيل، لا الكشف وحده.",
      benefits: [
        { "title": "استجابة أسرع للحوادث", "text": "تساعد رؤية الأجهزة والتنبيهات المركزية الفرق على التصرف بوضوح أكبر وقت الطوارئ." },
        { "title": "استراتيجية تنفيذ مرنة", "text": "تتكيف الخيارات السلكية واللاسلكية والهجينة مع ظروف المبنى والتنفيذ المرحلي." },
        { "title": "استمرارية التشغيل", "text": "تدعم برامج المراقبة والمعمارية الموثوقة الامتثال وتقلل مخاطر التوقف." }
      ],
      lines: "خطوط الحلول",
      linesTitle: "محفظة متكاملة من الأجهزة الميدانية إلى برامج المراقبة.",
      linesText: "يتضمن كل حل وثائق تقنية لمساعدة فريقك في تقييم الملاءمة ونموذج التنفيذ والقدرات.",
      features: [
        { "title": "أنظمة معنونة ذكية", "desc": "لوحات FLASHLINK مع مراقبة دقيقة للأجهزة وتوسع شبكي وتحكم مركزي." },
        { "title": "أنظمة إنذار تقليدية", "desc": "كشف موثوق واقتصادي للمرافق الصغيرة والتصاميم البسيطة." },
        { "title": "تنفيذ لاسلكي وهجين", "desc": "كشف لاسلكي شبكي للمساحات صعبة التوصيل والتوسعات ومشاريع التحديث." },
        { "title": "برامج المراقبة والاستجابة", "desc": "لوحات مركزية وخرائط وأوامر عن بُعد ورؤية تشغيلية فورية." }
      ],
      design: "منظور التصميم",
      designTitle: "يبدأ النظام الصحيح من الموقع، لا من الكتيب.",
      designText: "يحدد تعقيد التحديث وتغطية الطوابق والتوصيلات والإخلاء والمراقبة التصميم النهائي. تتعامل السنايا معه كمشروع سلامة هندسي.",
      faqs: [
        { "q": "كيف أختار بين النظام المعنون والتقليدي؟", "a": "يناسب المعنون المواقع الأكبر لأنه يحدد الجهاز، بينما يناسب التقليدي المساحات الأصغر عندما تكون البساطة والميزانية أهم." },
        { "q": "هل يمكن دمج الأجهزة السلكية واللاسلكية؟", "a": "نعم، تستخدم التصاميم الهجينة اللاسلكي في المناطق الصعبة والسلكي حيث يكون عملياً." },
        { "q": "هل تدعمون المراقبة عن بُعد؟", "a": "نعم، تعرض البرامج الإنذارات وحالات الأجهزة وإجراءات الاستجابة في واجهات مركزية." },
        { "q": "ما المرافق المناسبة لهذه الأنظمة؟", "a": "يمكن تغطية المباني التجارية والفنادق والمواقع الصناعية والجامعات والبيئات متعددة المناطق بالتصميم المناسب." }
      ],
      consultation: "استشارة سلامة",
      consultationTitle: "هل تخطط لمرفق جديد أو توسعة أو ترقية للامتثال؟"
    }
  }
};
